import ReferralSettingsCard from "pages/settings/ReferralSettingsCard";

// Pengaturan -> Sistem Reward -> Referral Program, reached from a tile on the
// Pengaturan launcher. Open to any Admin since 2026-08-20; the config
// endpoints' Manager gate was lifted to match. The card renders the page
// heading itself, because the program status and its turn-off action sit
// there.
const ReferralProgramPage = () => <ReferralSettingsCard />;

export default ReferralProgramPage;
